import { withProps } from 'recompose'

import {
  defaulCrudConfigMaker,
  CRUDRouteMaker,
} from '@infotech/crud'
import createFiltersConfig from '@infotech/filters'

import {
  getColumnsConf,
  getFormConfig,
  defaultFormList,
  getViewConfig,
  defaultViewList,
  defaultFormListEdit,
  defaultFilterList,
  getFilterConfig,
} from './fieldsConf'
import {
  apiUrl as logsApiUrl,
  LOGS_SCHEMA_NAME,
} from '../api/logs'
import { CRUD_PATH } from './constants'
import CRUDlist from './components/CRUDlist'
import { CRUD_PATH as parentPath } from '../servicesCRUD/constants'

const parentPathGenerator = (state, id) => `/${parentPath}/${id}/${LOGS_SCHEMA_NAME}`

const filtersConfig = createFiltersConfig({
  entityName: LOGS_SCHEMA_NAME,
})

export const defaultModuleConfig = {
  getGridConfig      : getColumnsConf,
  getFormConfig,
  getViewConfig,
  shouldRequestCount : false,
  getSortQueryParam  : undefined,
  parseSortQueryParam: undefined,
  defaultFormList,
  defaultViewList,
  defaultFormListEdit,
  routing            : {
    list: {
      title         : `Логи`,
      component     : CRUDlist,
      toolbarButtons: [],
      filter        : {
        saveManagement: false,
        defaultFilterList,
        getFilterConfig,
        ...filtersConfig,
      },
      pagination: {
        limitOptions: [],
      },
    },
    create: {
      title            : `Добавление лога`,
      submitButtonText : `Сохранить`,
      getSuccessMessage: (id) => `Лог № ${id} создан`,
    },
    edit: {
      title            : `Редактирование лога`,
      submitButtonText : `Сохранить`,
      getSuccessMessage: (id) => `Лог № ${id} отредактирован`,
    },
    read: {
      parentPathGenerator,
      rightWidgets : [],
      bottomWidgets: [],
    },
  },
}

export const moduleCrudConfig = (
  moduleConfig = defaultModuleConfig,
  crudPath = CRUD_PATH,
  apiUrl = logsApiUrl,
) => defaulCrudConfigMaker(moduleConfig, crudPath, apiUrl)

export const CRUDRoute = (
  config = moduleCrudConfig(),
  path = CRUD_PATH
) => {
  const component = CRUDRouteMaker(config, path, undefined, moduleCrudConfig)
  return withProps({
    parentPath: `${parentPath}/:id`,
  })(component)
}
